import React, { useState } from 'react';
import { Container, Row, Col, FloatingLabel, Form, Button, Alert, Card, CardBody, CardTitle, CardText } from 'react-bootstrap';

function Contact() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [showAlert, setShowAlert] = useState(false);
  const title = "Contact Us";
  const description = "We would love to hear from you. Please fill out the form below to get in touch.";
  const handleSubmit = (e) => {
    e.preventDefault();
    setShowAlert(true);
    // Here you can handle the form submission, e.g., send the data to a server
  };

  return (
    <Container className='mt-3'>
      {showAlert && (
        <Alert variant="success" onClose={() => setShowAlert(false)} dismissible>
          Thank you for contacting us!
        </Alert>
      )}
      <Card className="mb-3">
        <CardBody>
          <CardTitle className="fw-bold">{title}</CardTitle>
          <CardText>{description}</CardText>
        </CardBody>
      </Card>
      <Row>
        <Col md="6" className="mb-3">
          <FloatingLabel controlId="floatingName" label="Name">
            <Form.Control
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Enter your name"
            />
          </FloatingLabel>
        </Col>
        <Col md="6" className="mb-3">
          <FloatingLabel controlId="floatingEmail" label="Email">
            <Form.Control
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
            />
          </FloatingLabel>
        </Col>
      </Row>
      <Row>
        <Col className="mb-3">
          <FloatingLabel controlId="floatingMessage" label="Message">
            <Form.Control
              as="textarea"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              placeholder="Enter your message"
              style={{ height: '150px' }}
            />
          </FloatingLabel>
        </Col>
      </Row>
      <Button variant="dark" onClick={handleSubmit}>
        Submit
      </Button>
    </Container>
  );
}

export default Contact;